import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../../pages/Home";
import Promotion from "../../pages/Promotion";
import Blog from "../../pages/Blog";
import LiveCasino from "../../pages/LiveCasino";
import Slot from "../../pages/Slot";
import Sportbook from "../../pages/Sportbook";
import Card from "../../pages/Card";
import Keno from "../../pages/Keno";
import Menu from "../../pages/Menu";
import Login from "../../pages/Login";
import Reviews from "../../pages/Reviews";

const PageContent = () => (
  <Routes>
    <Route path="/" element={<Navigate to="/home" replace />} />
    <Route path="/login" element={<Login />} />
    {/* referral links: RegisterModal reads ?friend= and ?campaign= from this URL */}
    <Route path="/register" element={<Login initialRegister />} />
    <Route path="/promotion" element={<Promotion />} />
    <Route path="/blog" element={<Blog />} />
    <Route path="/livecasino" element={<LiveCasino />} />
    <Route path="/slot" element={<Slot />} />
    <Route path="/sportbook" element={<Sportbook />} />
    <Route path="/card" element={<Card />} />
    <Route path="/keno" element={<Keno />} />
    <Route path="/menu" element={<Menu />} />
    <Route path="/home" element={<Home />} />
    <Route path="/reviews" element={<Reviews />} />
  </Routes>
);

export default PageContent;
